module.exports = __webpack_public_path__ + "static/media/pauldron-2.5951204a.glb";